import { useTranslation } from "react-i18next";
import { PageSidebar } from "@inductiveautomation/ws-components";

const DeleteAccountConfirmation = () => {
  const { t } = useTranslation("translation", {
    keyPrefix: "profile.confirmation.delete_account",
  });

  return (
    <PageSidebar
      testId="primary-email-confirmation"
      heading={t("heading")}
      supportingText={t("description")}
    />
  );
};

export default DeleteAccountConfirmation;
